// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2UWYg","info":"PatientInfo_info__2Jr-9"};